/**
 * Returns the in-app route for links that point back to GSTAR, or null for
 * anything that must keep opening in a new browser tab.
 */
export function resolveInternalAppLink(
  url: string | null | undefined
): string | null {
  const candidate = url?.trim();

  if (!candidate || candidate.startsWith('//')) {
    return null;
  }

  if (candidate.startsWith('/')) {
    return candidate;
  }

  if (!/^https?:\/\//i.test(candidate)) {
    return null;
  }

  try {
    const parsed = new URL(candidate);
    return parsed.origin === window.location.origin
      ? `${parsed.pathname}${parsed.search}${parsed.hash}`
      : null;
  } catch {
    return null;
  }
}
